"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _propTypes = require("../text/propTypes");
var _propTypes2 = require("../prop-types");
var _interfaces = require("./interfaces");
const linkPropTypes = exports.linkPropTypes = {
  ..._propTypes.textSharedPropTypes,
  children: _stencilReactDesc.PropTypes.node.description('Elements displayed which will be clickable.'),
  icon: _stencilReactDesc.PropTypes.node.description('Icon element that will be added on the leading or trailing side of the link.'),
  iconPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.LinkIconPosition)).description('Determines on which side the icon will be placed.'),
  iconVerticalAlign: (0, _propTypes2.cssValue)().description("Sets the CSS 'vertical-align' property for the container holding the icon."),
  href: _stencilReactDesc.PropTypes.string.description('Target location for the link to navigate to.'),
  textDecoration: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.LinkTextDecorationOptions)).description("Sets the CSS 'text-decoration' property for the element. Only accepts \"none\" or \"underline\".")
};